<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M6.91.586a1 1 0 0 0-1.82.828l.689 1.516h-.29A3.488 3.488 0 0 0 2 6.42V17.58a3.488 3.488 0 0 0 3.488 3.489h8.536l1.066 2.344a1 1 0 0 0 1.82-.828l-10-22Zm2.308 9.91-2.805-6.17h-.925a2.093 2.093 0 0 0-2.093 2.093v8.488l3.451-4.026a1.862 1.862 0 0 1 2.372-.385Zm9.294 10.574h-.29l-3.617-7.955.73-.73a1.86 1.86 0 0 1 2.632 0l2.638 2.638V6.42a2.093 2.093 0 0 0-2.093-2.093H10.61L9.976 2.93h8.536A3.488 3.488 0 0 1 22 6.42V17.58a3.488 3.488 0 0 1-3.488 3.489ZM13.86 10.14c-.233 0-.457-.043-.662-.122l-1.084-2.383a1.861 1.861 0 1 1 1.746 2.505Z"
		fill="currentColor"
	/>
</svg>
